<div class="custom-image-main">
  <img class="image" [src]="imageUrl()" />
</div>
